@if (alert?.message?.files != null) {
  <mat-icon>attach_file</mat-icon>
}
@if (alert?.location?.point) {
  <mat-icon>location_on</mat-icon>
}
@if (alert?.location?.areas?.length) {
  <mat-icon>map</mat-icon>
}
@if (alert?.location?.facilities?.length === 1) {
  <mat-icon>domain</mat-icon>
}
@if (alert?.location?.facilities?.length > 1) {
  <mat-icon>location_city</mat-icon>
}
@if (alert?.weatherAlert) {
  <mat-icon>cloud</mat-icon>
}
@if (alert?.message?.severityAssessment != null) {
  <mat-icon>done</mat-icon>
}